import React, { useEffect, useState } from 'react';
import '../css/AboutBanner.css';
import { motion } from 'framer-motion';
import aboutbanner from "../../components/img/aboutbanner.jpg";

const AboutBanner = () => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    fetch("https://adinathbuilder.com/admin/api/team/members")
      .then(res => res.json())
      .then(data => {
        if (data && Array.isArray(data.data)) {
          setMembers(data.data);
        } else {
          console.error("Invalid members data format", data);
          setMembers([]);
        }
      })
      .catch(err => {
        console.error("Error fetching team members:", err);
        setMembers([]);
      });
  }, []);

  return (
    <div className="banner-container">
      {/* Banner */}
      <div>
        <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={aboutbanner} className="d-block w-100 banner-image" alt="..." />
            </div>
          </div>
        </div>
      </div><br /><br />

      {/* Static Content */}
      <div className="text-white p-6 max-w-4xl text-start ms-3">
        <h2 className="text-3xl font-bold mb-6 border-b border-white pb-2">Profile / Overview</h2>
        <p>
          Since the inception, Adinath has 19 years of track record of sustained growth, customer satisfaction, and innovation. 
          The company offers an array of real estate solutions to its customers viz. land, land and property sale, dealing in 
          homes and land properties to name a few.
        </p><br />
        <p>
          Over the years, Adinath has established itself as a major brand in the real estate sector, along with our relentless 
          pursuit towards the wellbeing of the environment, community, and people as a whole. We are working towards turning 
          our valued customer’s dreams into a reality.
        </p><br />
        <p>
          The sheer hard work and integrity of our management have resulted in the showers of appreciation and faith by our satisfied customers.
        </p><br />

        <h3>Best of the industry practices</h3>
        <p>
          Supported by an advanced information system, our highly efficient management delivers accurate estimates and effective cost control. 
          We are on a mission to provide customer satisfaction and create value for stakeholders through best of the industry practices, 
          professionalism, transparency, quality, cutting-edge technology, and social responsibility.
        </p><br />

        <h3>Philosophy</h3>
        <p>
          Adinath’s business philosophy derives its strength from the belief that customer satisfaction is our real and primary motive, 
          above the growth in figures and revenues — which we believe is nothing but one of the outcomes of client’s happiness and satisfaction.
        </p><br />
        <p>
          Adinath, with its unparalleled business approach and vision, is consistently working to create value for its customers and 
          business partners. Adinath Builders is uniquely committed to serve its clients.
        </p><br />

        <h3>OUR VISION</h3>
        <p>
          The vision of Adinath Builders is to achieve the highest possible standards of the real estate market while establishing 
          our company as the most trusted and preferred real estate company.
        </p><br />

        <h3>OUR MISSION</h3>
        <p>
          At Adinath, our mission is to modernize the experience of buying and selling real estate by cultivating a spirit of 
          collaboration innovation and integrity.
        </p><br />

        <h3>A NAME CALLED TRUST</h3>
        <p>
          The company fasters a culture of partnership in which all clients are represented in a cooperative environment by the management.
        </p><br />
        <p>
          Our foremost mission is to glorify the God by putting our clients interests above our own providing the biggest level of 
          honesty and expertise. Our collaboration spirit and desire to grow will help us achieve the goals we set. We will make the 
          families we serve feel special, creating raving fans, and help them truly win. We will succeed because we will not let 
          our clients fail.
        </p>
      </div>

      {/* Dynamic Members */}
      <div className="container">
        {Array.isArray(members) && members.map((member, index) => (
          <div
            className={`row my-5 align-items-center ${index % 2 !== 0 ? "flex-md-row-reverse" : ""}`}
            key={member.id}
          >
            <div className="col-12 col-md-6 text-center mb-4 mb-md-0 glow-image">
              <motion.img
                src={`https://adinathbuilder.com/admin/public/${member.image}`}
                className="img-fluid enlarged-member-image"
                alt={member.name}
                initial={{ x: index % 2 === 0 ? '-100vw' : '100vw' }}
                animate={{ x: 0 }}
                transition={{ type: 'spring', stiffness: 50 }}
              />
            </div>
            <div className="col-12 col-md-6">
              <motion.div
                className="content px-3"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 1.5 }}
              >
                <h1 className="style-T text-start text-white">{member.name}</h1>
                <div className="yellow-line mb-4"></div>
                <p className="text-start text-white">{member.description}</p><br /><br />
                <p className="text-start text-white"><b>{member.quote}</b></p>

                <h5 className="text-start text-white mt-4">{member.progress1_title}</h5>
                <div className="progress-bar">
                  <div className="progress-bar-fill" style={{ width: '100%' }}>
                    <span className="progress-bar-percentage">{member.progress1_value}</span>
                  </div>
                </div>

                <h5 className="text-start text-white mt-4">{member.progress2_title}</h5>
                <div className="progress-bar">
                  <div className="progress-bar-fill" style={{ width: '100%' }}>
                    <span className="progress-bar-percentage">{member.progress2_value}</span>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutBanner;
